// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__34YMY","errors":"Errors_errors__1DewF"};